export default __webpack_public_path__ + "static/media/payment-method-american-express-grey-icon.adb5a1c9.svg";